import { render } from "./UserFactsForm.vue?vue&type=template&id=2b9477df&scoped=true"
import script from "./UserFactsForm.vue?vue&type=script&lang=js"
export * from "./UserFactsForm.vue?vue&type=script&lang=js"

import "./UserFactsForm.vue?vue&type=style&index=0&id=2b9477df&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2b9477df"

export default script